export declare type MetaAttrs = Record<string, any>;

export const useMeta = () => {
  const metaTag = (info: {
    title: string|undefined;
    description?: string;
    type?: string;
    image?: string;
    url: string;
    domain?: string;
  }): Array<MetaAttrs> => {
    const { localeProperties } = useI18n();
    if (!info.type) {
      info.type = "website";
    }
    if (!info.domain) {
      info.domain = "qrdove.com";
    }
    var ogs: Array<MetaAttrs> = [];
    var twitters: Array<MetaAttrs> = [];
    const keyInOg = ["url", "title", "type", "description", "image"];
    const keyTwitter = ["url", "title", "domain", "description", "image"];
    Object.keys(info).forEach((item) => {
      if (keyInOg.includes(item)) {
        ogs.push({
          property: "og:" + item,
          //@ts-ignore
          content: info[item],
        });
      }
      if (keyTwitter.includes(item)) {
        twitters.push({
          name: "twitter:" + item,
          //@ts-ignore
          content: info[item],
        });
      }
    });
    return [...ogs, ...twitters];
  };
  return {
    metaTag,
  };
};
